/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from '../../../../components/Toast/ToastManager';
import {
  DEFAULT_TOAST_ERROR_MESSAGE,
  DEFAULT_TOAST_ERROR_TITLE,
} from '../../../../../constants';

export enum ToastersTitle {
  'Mapping saved' = 0,
  'Mapping saved ' = 1,
  'Mapping uploaded' = 2,
  'Upload Failed' = 3,
}

export const successToastr = (response: {
  messageType: 0 | 1 | 2 | 3;
  errorMessage: string;
  result: { message: string };
}) => {
  /* Just a string manipulation. */
  let Message: string[] = [];
  Message = response?.errorMessage.split('"');
  Message[1] = `<b>"${Message[1]}"</b>`;
  /* Showing a toastr. */
  toast.show({
    type: response?.messageType === 2 ? 'success' : 'info',
    title: ToastersTitle[response?.messageType],
    content: Message.join(''),
    duration: 6000,
  });
};

export const showDefaultErrorToaster = () => {
  toast.show({
    type: 'error',
    title: DEFAULT_TOAST_ERROR_TITLE,
    content: DEFAULT_TOAST_ERROR_MESSAGE,
    duration: 6000,
  });
};

export const errorToaster = (response: { data: { errorMessage: string } }) => {
  toast.show({
    type: 'error',
    title: ToastersTitle[3],
    content: response?.data?.errorMessage || DEFAULT_TOAST_ERROR_MESSAGE,
    duration: 6000,
  });
};
